// How to update the list?
// logger.log(' ', router.getRoutes().filter(el => el.name).map(el => `'${el.name}'`).sort().join(' |\n  '))

import type { RoutesName } from '~/typings/vue-router'

export type IPageManager = Map<RoutesName, boolean>

export enum IPageManagerMode {
  ALLOW = 'allow',
  DENY = 'deny',
}

export interface IPageManagerConfig {
  mode: IPageManagerMode
  pages: RoutesName[]
}
